import { Box, Heading, Image, SimpleGrid, Text } from '@chakra-ui/react';
import universalVaultIllustration from 'illustrations/universal_vault.svg';

const UniversalVault = () => (
  <SimpleGrid columns={[1, 1, 2]} py={[4, 4, 16]} alignItems='center'>
    <Box gridRow={[2, 2, 'auto']}>
      <Heading size='2xl' mb={6}>
        A{' '}
        <Box as='span' color='cyan.500'>
          Universal Vault
        </Box>{' '}
        to securely store your ERC20 tokens.
      </Heading>
      <Text color='gray.300' fontSize='lg'>
        A Crucible is more than just a smart wallet, it's a vault in the form of
        an NFT. It's designed to safeguard your investments, allowing you to
        receive rewards from multiple staking programs without your tokens ever
        leaving your possession.
      </Text>
    </Box>
    <Image src={universalVaultIllustration} mx='auto' pt={[8, 8, 0]} />
  </SimpleGrid>
);

export default UniversalVault;
